import React from "react";
import { IconDownload, IconEye } from "@tabler/icons-react";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import DropdownFilter from "../../../components/common/DropdownFilter";
import NormalSearch from "../../../components/common/NormalSearch";
import ListView from "../../../components/common/ListView";
const lineHaulCompanyRequest = [
  {
    id: 1,
    requestId: "#LH-00123",
    from: "Riyadh",
    to: "Dammam",
    volume: "15m³",
    weight: "15m³",
    date: "4 Aug 2025",
    active: false,
  },
  {
    id: 2,
    requestId: "#LH-00123",
    from: "Riyadh",
    to: "Dammam",
    volume: "15m³",
    weight: "15m³",
    date: "4 Aug 2025",
    active: true,
  },
  {
    id: 3,
    requestId: "#LH-00123",
    from: "Riyadh",
    to: "Dammam",
    volume: "15m³",
    weight: "15m³",
    date: "4 Aug 2025",
    active: false,
  },
  {
    id: 4,
    requestId: "#LH-00123",
    from: "Riyadh",
    to: "Dammam",
    volume: "15m³",
    weight: "15m³",
    date: "4 Aug 2025",
    active: true,
  },
  {
    id: 5,
    requestId: "#LH-00123",
    from: "Riyadh",
    to: "Dammam",
    volume: "15m³",
    weight: "15m³",
    date: "4 Aug 2025",
    active: true,
  },
];

const RequestsCompanies: React.FC = () => {
  return (
    <>
      <div className="p-4 space-y-4">
        <div className="bg-[#F7F6F2] rounded-3xl">
          <div className="flex justify-between items-center w-full  p-4">
            <div className="flex justify-between items-center  rounded-tl-3xl rounded-tr-3xl">
              <h1 className="text-3xl text-[#212121]">Requests Companies</h1>
            </div>
            <div className=" flex items-center gap-2 justify-end rounded-full">
              <div className="flex items-center gap-2">
                <ColumnsFilter columnsData={[]} />
                <DropdownFilter filterheadings={[]} />
                <NormalSearch />
              </div>
              <button className="flex items-center gap-1 py-2 px-4 text-sm rounded-full border border-[#D8D8D8] bg-white">
                <IconDownload /> Export
              </button>
            </div>
          </div>
          <div>
            {" "}
            <ListView
              data={lineHaulCompanyRequest}
              onRowClick={(client) => console.log("Clicked:", client)}
              columns={[
                { label: "S/N", render: (_, i) => i + 1 },
                {
                  label: "Request ID",
                  render: (c) => c.requestId,
                },
                {
                  label: "From",
                  render: (c) => c.from,
                },
                { label: "To", render: (c) => c.to },
                {
                  label: "Weight",
                  render: (c) => c.weight,
                },
                {
                  label: "Volume",
                  render: (c) => c.volume,
                },
                { label: "Submitted On", render: (c) => c.date },
                {
                  label: "Actions",
                  render: () => (
                    <div className="flex items-center gap-1">
                      <button className="p-2 border rounded-full bg-[#F7F6F2]">
                        <IconEye size={18} />
                      </button>
                    </div>
                  ),
                },
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestsCompanies;
